import React from 'react';
import { format } from 'date-fns';
import { useDispatch } from 'react-redux';
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';
import {
  setRegStartDate,
  setLrInstallerSubmitClaimStartDate,
  setLrClaimStartDate,
  setPmcStartDate,
  setPmcClientRegStartDate,
} from '../features/ga/gaSlice';

const useGaStartEvent = (journeyCategory, eventName) => {
  const sendDataToGTM = useGTMDispatch();
  const dispatch = useDispatch();
  React.useEffect(() => {
    const startDate = format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx");
    if (journeyCategory.trim() === 'LandlordRegistration')
      dispatch(setRegStartDate(startDate));
    else if (journeyCategory.trim() === 'LanlordInstallerSubmitClaim')
      dispatch(setLrInstallerSubmitClaimStartDate(startDate));
    else if (journeyCategory.trim() === 'LanlordSubmitClaim')
      dispatch(setLrClaimStartDate(startDate));
    else if (journeyCategory.trim() === 'PmcSubmitClaim')
      dispatch(setPmcStartDate(startDate));
    else if (journeyCategory.trim() === 'PmcClientRegistration')
      dispatch(setPmcClientRegStartDate(startDate));

    sendDataToGTM({
      event: eventName,
      category: journeyCategory,
    });
  }, []);
  return () => {};
};

export default useGaStartEvent;
